/**
 * Welcher Score-Typ fuer eine vom Nutzer ausgeloeste Neuberechnung bestellt
 * wird (UX-Audit A2-NEU-3, Entscheidung Dennis 06.10.2026: "Nachher rechnen").
 *
 * Die Feed-Check-Seite zeigt den JUENGSTEN Befund. Bestellte "Neu pruefen" auf
 * einem optimierten Feed weiter `pre_optimization`, ersetzte der Vorher-Befund
 * den Nachher-Befund in der Anzeige (Truck-Servicecenter: aus 92 A wurde 62 C
 * mit rotem Minus). Deshalb: hat der Feed optimierte Produkte, wird
 * `post_optimization` bestellt (der Server scort dann nur die optimierten
 * Produkte), sonst `pre_optimization`.
 *
 * Unbekannt (Zaehlung laedt noch oder ist gescheitert) heisst
 * `pre_optimization`: das ist das bisherige Verhalten, und ein geratenes
 * `post_optimization` endete ohne optimierte Produkte serverseitig im 404.
 */
export type ScoreType = 'pre_optimization' | 'post_optimization';

export function scoreTypeForFeed(completedCount: number | null | undefined): ScoreType {
  return typeof completedCount === 'number' && Number.isFinite(completedCount) && completedCount > 0
    ? 'post_optimization'
    : 'pre_optimization';
}
